import { NursingArea } from './nursing-area';

export enum TypeOfWork {
  Ambulant = 'ambulant_care',
  DentalPractice = 'dental_practice',
  DoctorOffice = 'doctor_office',
  Hospice = 'hospice',
  Hospital = 'hospital',
  Intensive = 'intensive',
  Leasing = 'leasing',
  MedicalCareCenter = 'medical_care_center',
  NursingHome = 'nursing_home',
  OutpatientPractice = 'outpatient_practice',
  PrivateClinic = 'private_clinic',
  RehabClinic = 'rehab_clinic',
  Sonstiges = 'others',
  Physiotherapy = 'physiotherapy',
  UniversityHospital = 'university_hospital',
}

export const DOCIA_ONLY_TYPES_OF_WORK = [
  TypeOfWork.UniversityHospital,
  TypeOfWork.MedicalCareCenter,
  TypeOfWork.OutpatientPractice,
  TypeOfWork.PrivateClinic,
];

export const DOCIA_TYPES_OF_WORK = [
  TypeOfWork.Hospital,
  TypeOfWork.UniversityHospital,
  TypeOfWork.MedicalCareCenter,
  TypeOfWork.OutpatientPractice,
  TypeOfWork.DentalPractice,
  TypeOfWork.RehabClinic,
  TypeOfWork.PrivateClinic,
  TypeOfWork.Sonstiges,
];

export const DOCIA_TYPES_OF_WORK_I18N: { [key in TypeOfWork]?: string } = {
  [TypeOfWork.Hospital]: 'Krankenhaus / Fachklinik',
  [TypeOfWork.UniversityHospital]: 'Universitätsklinikum',
  [TypeOfWork.MedicalCareCenter]: 'MVZ (Medizinisches Versorgungszentrum)',
  [TypeOfWork.OutpatientPractice]: 'Praxis (ambulant)',
  [TypeOfWork.DentalPractice]: 'Zahnarztpraxis / Z-MVZ',
  [TypeOfWork.RehabClinic]: 'Rehabilitationsklinik',
  [TypeOfWork.PrivateClinic]: 'Privatklinik',
  [TypeOfWork.Sonstiges]: 'Egal',
};

export const TYPES_OF_WORK_WITH_DEPARTMENTS = [
  TypeOfWork.Leasing,
  TypeOfWork.Hospital,
  TypeOfWork.RehabClinic,
  TypeOfWork.DentalPractice,
  TypeOfWork.DoctorOffice,
  TypeOfWork.Sonstiges,
];

const addSonstiges = (types: TypeOfWork[], showSonstiges: boolean) => (showSonstiges ? [...types, TypeOfWork.Sonstiges] : types);

const DEFAULT = [
  TypeOfWork.NursingHome,
  TypeOfWork.Ambulant,
  TypeOfWork.Hospital,
  TypeOfWork.Intensive,
  TypeOfWork.DentalPractice,
  TypeOfWork.DoctorOffice,
  TypeOfWork.Physiotherapy,
];
const ELDERY_CARE = [TypeOfWork.NursingHome, TypeOfWork.Ambulant, TypeOfWork.Hospital, TypeOfWork.Intensive];
const FOR_NURSING = [TypeOfWork.Hospital, TypeOfWork.Intensive, TypeOfWork.NursingHome, TypeOfWork.Ambulant];
export const MEDICAL_STAFF_TYPES_OF_WORK = [
  TypeOfWork.DoctorOffice,
  TypeOfWork.DentalPractice,
  TypeOfWork.Hospital,
  TypeOfWork.Physiotherapy,
];

const TYPES_OF_WORK_MAP: { [key in NursingArea]?: TypeOfWork[] } = {
  [NursingArea.ElderlyCare]: ELDERY_CARE,
  [NursingArea.Nursing]: FOR_NURSING,
  [NursingArea.MedicalStaff]: MEDICAL_STAFF_TYPES_OF_WORK,
};

export const getTypesOfWork = (showSonstiges: boolean, nursingArea?: NursingArea) => {
  if (!nursingArea) return DEFAULT;

  const types = TYPES_OF_WORK_MAP[nursingArea] || DEFAULT;
  return addSonstiges(types, showSonstiges);
};
